import type { Styles } from '@adornis/ass/style';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/chemistry/elements/components/x-flex';
import { xComponents } from '@adornis/chemistry/elements/x-components';
import { XCheckbox } from '@adornis/forms/x-checkbox';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { FPSColors } from '../theme/theme';

/**
 * @element fps-checkbox
 */
@customElement('fps-checkbox')
export class FpsCheckbox extends XCheckbox {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        '#circle': {
          border: '2px solid',
          borderColor: FPSColors.pureBlack,
          background: this.value.value ? FPSColors.pureBlack : this.colors.white,
          color: this.colors.white,
          transition: 'all .3s ease-in-out',
          marginTop: '-1px',
          marginBottom: 'auto',
        },
      },
    ];
  }

  override render() {
    return xComponents(html`
      <x-flex
        tabindex="0"
        horizontal
        space="sm"
        crossaxis-start
        ${css({ cursor: this.disabled ? 'initial' : 'pointer' })}
        @keyup=${(e: KeyboardEvent) => {
          if (e.key === 'Enter') this._toggle();
        }}
        @click=${() => this._toggle()}
      >
        ${this._circle()}
        ${this.label
          ? html`
              <x-text tone=${this.error || this.getAttribute('error') === '' ? 'error' : ''}> ${this.label} </x-text>
            `
          : nothing}
      </x-flex>
    `);
  }
}
